import { render } from "./FilterList.vue?vue&type=template&id=2dfc8475&scoped=true"
import script from "./FilterList.vue?vue&type=script&lang=js"
export * from "./FilterList.vue?vue&type=script&lang=js"

import "./FilterList.vue?vue&type=style&index=0&id=2dfc8475&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfc8475"]])

export default __exports__